import clsx from 'clsx';
import { ReactNode } from 'react';
import { formatDuration } from '../lib/format';

/** Cartão de número (painel e relatórios). */
export function Stat({ label, value, hint, tone }: { label: string; value: ReactNode; hint?: string; tone?: 'warn' | 'ok' | 'accent' }) {
  return (
    <div className="rounded-lg border border-border bg-panel px-4 py-3" title={hint}>
      <div className="text-xs text-fg-soft">{label}</div>
      <div className={clsx('mt-0.5 text-2xl font-semibold tabular-nums', tone === 'warn' && 'text-warn', tone === 'ok' && 'text-ok', tone === 'accent' && 'text-accent')}>{value}</div>
    </div>
  );
}

/** Duração para os relatórios ("—" quando não há dado). */
export const duration = (s: number | null | undefined) => (s === null || s === undefined ? '—' : formatDuration(s));
